import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { RadioFormField } from "@components/FormField/HookFormFields";
import { yesNo } from "@config/StepperForm";
import { FullWidthInputWrapper, StepperFormRow } from "@components";
import { selectClientChannelOptions } from "@redux";

export const OtherInformation = ({ control }) => {
  const clientChannelOptions = useSelector(selectClientChannelOptions);

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.Confirmation)}</p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <p className="form-part-description">{trb(i18.Messages.Confirmation)}</p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.PersonalDataProccessing)}</p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <p className="form-part-description">{trb(i18.Messages.PersonalDataProccessing)}</p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientProfile.0.data.directMarketing"
          title={trb(i18.Labels.DirectMarketing)}
          options={yesNo}
          optionsLabel="label"
          optionsValue="value"
          inline
          defaultValue={0}
          translationGroup={i18.Labels}
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientProfile.0.data.clientChannel"
          title={trb(i18.Labels.ClientChannel)}
          options={clientChannelOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>
    </StepperFormRow>
  );
};
